
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"24.89","cy":"24.89","r":"23.6","fill":"#fff","stroke":"#515358","stroke-miterlimit":"10","stroke-width":"1.2"}}),_c('path',{attrs:{"d":"M25 .49A24.51 24.51 0 1049.51 25 24.51 24.51 0 0025 .49zm13 25.24a1.75 1.75 0 01-1.44.49v11.12a1.75 1.75 0 01-1.75 1.75H15.09a1.75 1.75 0 01-1.75-1.75V26.19a1.75 1.75 0 01-1.39-3l11.79-11.77a1.76 1.76 0 012.48 0l11.83 11.82a1.77 1.77 0 010 2.49z","fill":"var(--primary-highlight)"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/uniFill.svg